/* jslint unparam: true, regexp: true */
/* global window, $ */

$(function () {
    'use strict';
    
    if (typeof window.LaravelDataTables !== 'undefined') {

        var LaravelDataTables = Object.keys(window.LaravelDataTables);
        LaravelDataTables.forEach(function(item) {

            var item = item.toString();
    
            window.LaravelDataTables[item].on( 'row-reorder', function ( e, diff, edit ) {
    
                var positions = [];
                    for ( var i=0, ien=diff.length ; i<ien ; i++ ) {
                        var rowData = window.LaravelDataTables[item].row( diff[i].node ).data();
                        positions.push({
                            id: rowData.id,			// record id from datatable
                            position: diff[i].newData		// new position
                        });
                    }
                var jsonString = JSON.stringify(positions);
                var currentPath = window.location.pathname;
                console.log(jsonString);
                $.ajax({
                    url     : currentPath + '/reorder',
                    headers : { 'X-CSRF-TOKEN': $( 'input[name="_token"]' ).val() },
                    type    : 'POST',
                    data    : jsonString,
                    dataType: 'json',
                    success : function ( response ) 
                    {
                        window.LaravelDataTables[item].ajax.reload(); // now refresh datatable
                        toastr.success('Reordering done.')
                    },
                    error : function ( response ) 
                    {
                        toastr.error('Reordering issue. Try again later.')
                    }
                })
    
            });
        });
    }

    // Date range picker
    if ( $('body').find('.daterange-picker').length > 0 ) {
        $('.daterange-picker').each(function() {
            var startDate = $(this).data('start-date');
            if (startDate === '') {
                startDate = moment().subtract(1, 'days')
            }
            var endDate = $(this).data('end-date');
            if (endDate === '') {
                endDate = moment().add(1, 'days')
            }
            $(this).daterangepicker({
                locale: {
                    format: 'DD/MM/YYYY'
                }/*,
                startDate: startDate,
                endDate: endDate
                */
            });
        });
    }

    if ( $('body').find('.date-picker').length > 0 ) {
        $( '.date-picker' ).daterangepicker({
            singleDatePicker: true,
            locale: {
                format: 'DD/MM/YYYY'
            }
        });
    }

    //Initialize Select2 Elements
    if ( $('body').find('.select2bs4').length > 0 )
        $('.select2bs4').select2({
            theme: 'bootstrap4',
            formatResult: function (data, term) {
                return data;
            },
            formatSelection: function (data) {
                return data;
            }
    })
        
    //Initialize Custom Inputs
    if ( $('body').find('.custom-control-input').length > 0 )
        bsCustomFileInput.init();
    
    var images = { "it": [], "en": [], "de": [], "es": [] };
    var nutritional = {"NRV1": {"gr": null, "item": null, "portion": null}, "NRV2": {"gr": null, "item": null, "portion": null}, "NRV3": {"gr": null, "item": null, "portion": null}};
    var nutritionals = $( 'input[name="nutritional_values"]' );
    var nutritionalsVal = nutritionals.val();
    var lang = $( 'input[name="lang"]' );
    
    if(nutritionals.length > 0 && nutritionalsVal != '' && nutritionalsVal.includes('NRV1'))
        var nutritional = JSON.parse(nutritionalsVal);

    if(nutritionals.length > 0) {
        if(nutritionalsVal != '' && nutritionalsVal.includes('NRV1')) {
            var data = $.parseJSON(nutritionalsVal);
            $.each(data, function(list, listArr) {
                var aList = list;
                $.each(listArr, function(type, typeArr) {
                    var aType = type;
                    if(Object.prototype.toString.call(typeArr) === '[object Object]')
                        $.each(typeArr, function(item, value) {
                            
                            if( item == 'grs' ) {
                                var values = value.split(' ');
                                value = values.shift();
                                var unit = values.pop();
                            }

                            var input = $( 'input[name="'+item+'[]"][data-list="'+aList+'"][data-type="'+aType+'"]' );
                            input.val(value)

                            if( item != 'grs' )
                                input
                                    .closest( '.input-group' )
                                    .find( 'input[type="checkbox"]' )
                                    .prop('checked', true);
                            else
                                input
                                    .closest( '.input-group' )
                                    .find( 'select' )
                                    .val(unit)
                                    .prop('selected', true)
                        });
                    else
                        $( 'input[name="item[]"][data-list="'+aList+'"]' )
                            .val( nutritional[aList]['item'] );
                });
            });
        }
    }

    $( '.nutritional-values input[type="text"], .nutritional-values input[type="number"]' ).keyup(function( e ) {
        
        var el      = $( this );
        var iName   = el.attr( 'name' );
        var sName   = iName.split('[]');
        var name    = sName[0];
        var type    = el.attr( 'data-type' );
        var list    = el.attr( 'data-list' );
        var val     = el.val();
        var unit    = 'gr';

        var listE   = nutritional[list] && nutritional[list] !== null;
        var typeE   = nutritional[list][type] && nutritional[list][type] !== null;

        if(!listE)
            nutritional[list] = {};

        if(name == 'item')
            nutritional[list]['item'] = val;
        else {
            
            if(!typeE)
                nutritional[list][type] = {};

            nutritional[list][type][name] = val;
        }

        if(name == 'item' || name == 'grs') {
            if(name == 'item')
                val.length < 1 || val == ' ' ? nutritional[list][name] = null : nutritional[list][name] = val;
            else {

                if( val.length < 1 || val == ' ' )
                    delete nutritional[list][type][name];
                else {
                    unit = el.closest( '.input-group' ).find( 'select' ).val();
                    nutritional[list][type][name] = val + ' ' + unit;
                }

                var key, count = 0;
                for(key in nutritional[list][type]) {
                    if(nutritional[list][type].hasOwnProperty(key))
                        count++;
                }

                if(count == 0)
                    nutritional[list][type] = null;
            }
        } else {
            $( this )
                .closest( '.input-group' )
                .find( 'input[type="checkbox"]' )
                .prop('checked', val.length > 0 )
                .trigger( 'change' );
        }
        
    });

    $( 'select[name="gr_unit"],select[name="portion_unit"]' ).change(function( e ) {

        var el = $( this );
        el
            .closest( '.input-group' )
            .find( 'input' )
            .keyup();
        
    });

    $( '.nutritional-values input[type="checkbox"]:not(.custom-control-input)' ).change(function( e ) {
        
        var checkbox    = $( this );
        var name        = checkbox.attr( 'data-input' );
        var type        = $( this ).attr( 'data-type' );
        var list        = $( this ).attr( 'data-list' );
        var val         = $( this ).closest( '.input-group' ).find( 'input[type="text"]' ).val();
        
        if ( !checkbox.is(':checked') ) {

            delete nutritional[list][type][name];

            var key, count = 0;
            for(key in nutritional[list][type]) {
                if(nutritional[list][type].hasOwnProperty(key))
                    count++;
            }

            if(count == 0)
                nutritional[list][type] = null;

        } else {
            if( val.length < 1 || val == ' ' )
                delete nutritional[list][type][name];
            else
                nutritional[list][type][name] = val;
        }

        var key, count = 0;
        for(key in nutritional[list][type]) {
            if(nutritional[list][type].hasOwnProperty(key))
                count++;
        }

        if(count == 0)
            nutritional[list][type] = null;
    });

    // Show/Hide nutritionals inputs
    $('input[name="shgrs[]"], input[name="shp[]"]').change(function () {
        var hide = $(this).attr('data-hide')
        $(this)
            .closest('.tab-pane')
            .find( 'input[data-type="'+hide+'"]' )
            .closest('[class*="col-"]')
            .fadeToggle( $(this).is(':checked') )
    })

    var objs = [];
    function ini_objects() { // $tab

        $( '.list' ).each(function () {

            var list = $( this );
            var listTab = list.closest('.trans-pane').attr('id');
            var tableList = list.find('.elements');
            var tabLang = listTab.split('-');
            var obj = list.attr( 'data-item' );
            var currentTabLang = '_' + tabLang[0];
            var langObj = obj+currentTabLang;
            
            objs[langObj] = [];
            var json = list.find( 'input[type="hidden"]' ).val();
            
            if(json.length > 0 && tableList.find('tr').length < 1) {
                var data = $.parseJSON(json);
                // get value from select if exist
                var dropdown = list.find('.-select');

                $.each(data, function(i, item) {
                    
                    if(Object.prototype.toString.call(item) === '[object Object]') {

                        i = item[Object.keys(item)[0]];
                        item = item[Object.keys(item)[1]];

                        if (list.find('.-new').is('select'))
                            item = i;

                    }

                    setTimeout(
                        function() {
                            if (dropdown.length != 0) {
                                list
                                    .find('.-select')
                                    .val( i )
                                    .end()
                                    .find('.-new')
                                    .val( item )
                                    .end()
                                    .find('.-add').click();
                                }
                            else
                                list
                                    .find('.-new')
                                    .val( item )
                                    .end()
                                    .find('.-add').click();
                        },
                    300);
                    
                });
            }
        
        });
    }
    
    //ini_objects($('a.trans-link.active[data-toggle="tab"]').attr('href'));
    ini_objects();

    /*
    $('a.trans-link[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        ini_objects($(e.target).attr('href'));
    });
    */

    var tr  = $('<tr />')
    var td  = $('<td />')
    var btn = $('<button />')
    var a   = $('<a />')
    var i   = $('<i />')
    var div = $('<div />')
    
    function fill( list, obj ) {
        list.val( JSON.stringify(objs[obj]) );
    }

    $(document).on('click', '.-delete', function( e ){

        e.preventDefault();
        
        var list = $( this ).closest( '.list' );
        var listTab = list.closest('.trans-pane').attr('id');
        var tabLang = listTab.split('-');
        var currentTabLang = '_' + tabLang[0];
        var obj = list.attr( 'data-item' );
        var langObj = obj+currentTabLang;
        var index = $( '.list' ).index( list );
        var closest = $( this ).closest( 'tr' );
        var value = closest.find( 'td:first-child()' ).text();
        
        objs[langObj].splice( objs[langObj].indexOf(value), 1 );
        closest.remove();

        fill( list.find( 'input[type="hidden"]' ), langObj );

    });

    $('.-erase').click(function (e) {
        if (confirm('Eliminare immagine?')) {
            $( '#detach' ).val( '1' );
            $( '#detach' )
                .closest( 'form' )
                .trigger( 'submit' );
        } else
            e.preventDefault();
    });


    $('.-add').click(function (e) {
      
        e.preventDefault();
        var list = $( this ).closest( '.list' );
        var listTab = list.closest('.trans-pane').attr('id');
        var tabLang = listTab.split('-');
        var currentTabLang = '_' + tabLang[0];
        var obj = list.attr( 'data-item' );
        var langObj = obj+currentTabLang;
        var index = $( '.list' ).index( list );
        // get value and make sure it is not null
        var val = list.find('.-new').val();
        if ( typeof val == typeof undefined || val == false || val.length == 0)
            return
        var select = list.find( '.-new option' );
        var edit = '';
        var icon = '';

        // get value from select if exist
        var dropdown = list.find('.-select');

        if (dropdown.length != 0) {
            if ( dropdown.val() == '')
                return
            icon = '<div class="w-50 w-xl-40 pr-2 float-sm-left text-center"><img src="/images/icons/brown/' + dropdown.val() + '.svg"></div>';
        }

        if (select.length != 0) {
            val = list.find( '.-new option:selected' ).text();
            edit = '/admin/extra-content/'+list.find( '.-new option:selected' ).val()+'/edit';
        }

        // add row
        list.find( 'tbody' ).append( tr.clone().append(
            [
                td.clone().html( icon + val ),
                td
                .clone()
                .addClass( 'text-right align-middle' )
                .html(
                    div
                        .clone()
                        .addClass( 'btn-group btn-group-sm' )
                        .append(
                            [
                                /*
                                a
                                    .clone()
                                    .attr( 'href', edit )
                                    .addClass( 'btn btn-warning -edit' )
                                    .append(
                                        i
                                            .clone()
                                            .addClass( 'fas fa-pencil-alt' )
                                    ),
                                */
                                a
                                    .clone()
                                    .attr( 'href', '' )
                                    .addClass( 'btn btn-danger -delete' )
                                    .append(
                                        i
                                            .clone()
                                            .addClass( 'fas fa-trash' )
                                    )
                            ]
                        )
                )
        ] ))

        // push into array
        if (dropdown.length != 0)
        {
            objs[langObj].push({
                image: dropdown.val(), 
                value: val
            });

            // clear input or select
            list.find('.-new')
                .val('')
                .end()
                .find('.-select')
                .prop("selectedIndex", 0);
        }
        else
        {
            if ( list.find( '.-new option' ).length == 0 )
                objs[langObj].push( val );
            else
                objs[langObj].push({
                    id: list.find('.-new').val(), 
                    value: list.find( '.-new option:selected' ).text()
                });

            // clear input or select
            list.find('.-new')
                .val('')
                .prop("selectedIndex", 0);
        }
            
        // fill hiddens
        fill( list.find( 'input[type="hidden"]' ), langObj );
      
    })

    // sort blueimp gallery items
    function updatepositions() {
        $( 'tr input[name="order"]').val(function() {
            return $(this).closest( 'tr' ).index( 'tbody.files tr' );
        });
    }
    function sortUp() {
        var current = $(this).closest( 'tr' );
        current.insertBefore(current.prev());
        updatepositions();
    }
    function sortDown() {
        var current = $(this).closest( 'tr' );
        current.insertAfter(current.next());
        updatepositions();
    }
    function sortItems() {
        $( 'tbody.files' ).sortable({
            handle: '.sort',
            placeholder: "ui-state-highlight",
            update: function(e, ui) {
                updatepositions();
            }
        });
        $( '.sort-up' ).on('click', sortUp);
        $( '.sort-down' ).on('click', sortDown);
    };

    // get format changes
    function getItemsChanges() {

        $( '.trans-pane.active tbody.files tr').each(function() {          
            var tr = $(this);
            var ix = $(this).closest( 'tr' ).index( '.trans-pane.active tbody.files tr' );
            var langTab = $( '.trans-pane.active' ).attr('id');
            var fileuploadLang = langTab.split('-');
            var currentFileUploadLang = fileuploadLang[0];

            images[currentFileUploadLang][ix].format       = tr.find( 'input[name="format"]' ).val();
            images[currentFileUploadLang][ix].link         = tr.find( 'input[name="link"]' ).val();
            images[currentFileUploadLang][ix].slide        = tr.find( 'input[name="slide"]:checked' ).val();
            images[currentFileUploadLang][ix].order        = tr.find( 'input[name="order"]' ).val();
            images[currentFileUploadLang][ix].description  = tr.find( 'textarea[name="itemdesc"]' ).val();
            images[currentFileUploadLang][ix].id_image     = parseInt(tr.find( 'input[name="id_image"]' ).val());
        });

        $( '.trans-pane.active input[name="main_slides"]' )
            .val( JSON.stringify(images[currentFileUploadLang]) );
    }

    var number_of_files = 0;
    var fileupload = $('.trans-pane.active .fileupload');
    var currentPath = window.location.pathname;
    var pathVars = currentPath.split('/');
    var id = pathVars[pathVars.length-2];
    var edit = pathVars[pathVars.length-1];
    var submitted = false;
    var spliceout = [];

    $('.fileupload').each(function () {
        $(this).fileupload({
            dropZone: $(this),
            //pasteZone: $(this),
            //  Uncomment the following to send cross-domain cookies:
            //  xhrFields: {withCredentials: true},
            url: '/admin/upload',
            fileInput: $(this).find('input[name="files[]"]'),
            autoUpload: false,
            acceptFileTypes: /(\.|\/)(gif|jpe?g|png|svg|pdf)$/i,
            maxFileSize: 5000000,
            prependFiles: false,
            /*
            Enable image resizing, except for Android and Opera,
            which actually support image resizing, but fail to
            send Blob objects via XHR requests:
            */
            disableImageResize: /Android(?!.*Chrome)|Opera/
                    .test(window.navigator.userAgent),
            previewMaxWidth: 160,
            previewMaxHeight: 160,
            previewCrop: false,
            /*
            imageMaxWidth: 100,
            imageMaxHeight: 100,
            imageCrop: true // Force cropped images
            */
        }).bind('fileuploadfail', function (e, data) {
            $.each(data.files, function (index, file) {
              number_of_files = number_of_files - 1;
            });
        }).bind('fileuploadadd', function (e, data) {

            $.each(data.files, function (index, file) {

                number_of_files = number_of_files + 1;

                setTimeout(
                    function() {
                        updatepositions();
                        $( '.sort-up' ).on('click', sortUp);
                        $( '.sort-down' ).on('click', sortDown);
                    },
                100);
            
            });

        }).bind('fileuploadfinished', function (e, data) {
            //console.log('end finished', images);
        }).bind('fileuploadprogressall', function (e, data) {
            /*
            var progress = parseInt(data.loaded / data.total * 100, 10);
            $('#progress .progress-bar').css(
                    'width',
                    progress + '%'
            );
            */
        }).bind('fileuploaddestroy', function (e, data) {
        
            var fileName = data.context.find( '.toggle' );
            var index = $( '.files .toggle' ).index( fileName );
            var checked = $( '.files .toggle:checked' );
            var description_formats = $( 'textarea[name="description_formats"]' ).val();

            spliceout.push(index);
            
            for (let i of spliceout.sort().reverse()) {

                var langTab = $( '.trans-pane.active' ).attr('id');
                var fileuploadLang = langTab.split('-');
                var currentFileUploadLang = fileuploadLang[0];

                images[currentFileUploadLang].splice(i, 1);

            }

            $.ajax({
                url: '/admin/delete/' + id,
                dataType: 'json',
                data: {
                    'main_slides': JSON.stringify(images),
                    'description_formats': description_formats
                },
                context: fileupload[0]
            }).done(function (result) {

                updatepositions();
                getItemsChanges();
                
                checked.closest( 'tr' ).fadeOut( 300, function() {
                    checked.closest( 'tr' ).remove();
                });
                
            });

        }).bind('fileuploadsubmit', function (e, data) {

            var inputs = data.context.find(':input');
            var data_format = data.context.find('input[name="format"]');
            var data_link = data.context.find('input[name="link"]');
            var data_description = data.context.find('textarea[name="itemdesc"]');
            var data_slide = data.context.find('input[name="slide"]');
            var data_order = data.context.find('input[name="order"]');

            data.formData = {
                _token: $( 'input[name="_token"]' ).val(),
                format: data_format.val(),
                link: data_link.val(),
                description: data_description.val(),
                slide: data_slide.val(),
                order: data_order.val()
            };

            if (inputs.filter(function () {
                    return !this.value && $(this).prop('required');
                }).first().focus().length) {
                data.context.find('button').prop('disabled', false);
                return false;
            }

        }).bind('fileuploaddone', function (e, data) {
            
            $.each(data.result.files, function (index, file) {

                file.format       = data.formData.format;
                file.link         = data.formData.link;
                file.description  = data.formData.description;
                file.slide        = data.formData.slide;
                file.order        = data.formData.order;
                file.id_image     = file['id_image'];

                data.context.find( 'input[name="id_image"]' ).val(file['id_image']);
                
                if (file.url) {

                    var langTab = $( '.trans-pane.active' ).attr('id');
                    var fileuploadLang = langTab.split('-');
                    var currentFileUploadLang = fileuploadLang[0];

                    images[currentFileUploadLang] = [
                        ...images[currentFileUploadLang],
                        {
                            format:       data.formData.format,
                            link:         data.formData.link,
                            slide:        data.formData.slide,
                            order:        data.formData.order,
                            description:  data.formData.description,
                            id_image:     parseInt(file['id_image'])
                        }
                    ];
                    
                } else if (file.error) {
                    var error = $('<span class="text-danger"/>').text(file.error);
                    $(data.context.children()[index])
                            .append('<br />')
                            .append(error);
                }
            });

            //$( 'input[name="main_slides"]' ).val( JSON.stringify(images) );
            
        }).bind('fileuploadstop', function (e, data) {
            if( submitted ) {
                updatepositions();
                getItemsChanges();

                var langTab = $( '.trans-pane.active' ).attr('id');
                var fileuploadLang = langTab.split('-');
                var currentFileUploadLang = fileuploadLang[0];

                var $form = $( '#' + currentFileUploadLang + '_product' );
                $form.trigger('submit');
            } 
        }).bind('fileuploadfail', function (e, data) {
            $.each(data.files, function (index) {
                var error = $('<span class="text-danger"/>').text('File upload failed.');
                $(data.context.children()[index])
                        .append('<br />')
                        .append(error);
            });
        });
    });

    // Load existing files
    if ( $('body').find('.fileupload').length > 0 && edit == 'edit' ) {
        $.ajax({
            url: '/admin/formats/' + id,
            dataType: 'json',
            context: fileupload[0]
        }).done(function (result) {
            fileupload
                .fileupload('option', 'done')
                .call(fileupload, $.Event('done'), {result: result});
                
                var i = 0;
                var files = result.files;
                var langTab = $( '.trans-pane.active' ).attr('id');
                var fileuploadLang = langTab.split('-');
                var currentFileUploadLang = fileuploadLang[0];
                
                $.each(files, function (index, file) {
                    images[currentFileUploadLang].push( 
                    {
                        format: file.format,
                        link: file.link,
                        slide: file.slide,
                        order: file.order,
                        description: file.description,
                        id_image: file.id_image
                    });
                    i++;
                });
                updatepositions();
                sortItems();
        });
    }

    // Auto upload file if they aren't yet
    if( $( 'body' ).find( '.trans-pane' ).length > 0 ) {

        var langTab = $( '.trans-pane.active' ).attr('id');
        var fileuploadLang = langTab.split('-');
        var currentFileUploadLang = fileuploadLang[0];
    
        var $form = $( '#' + currentFileUploadLang + '_product' );

        $form.on('submit', function (e) {

            if(nutritionals.length > 0)
                nutritionals.val(JSON.stringify(nutritional));
    
            //e.preventDefault();
    
            if ( $( '.files' ).find( '.btn-primary.start' ).length > 0 ) {
                e.preventDefault();
                submitted = true;
                toastr.warning('Uploading formats.')
                $( this ).find( '.fileupload-buttonbar>.btn-primary.start' )
                    .trigger('click');
            }
    
            if( !submitted ) {
                updatepositions();
                getItemsChanges();
            }
            //e.preventDefault();
        });
    }

    // Summernote text editor
    var clearAllButton = function (context) {

        var ui = $.summernote.ui;
      
        // create button
        var button = ui.button({
          contents: '<i class="fa fa-trash"/>',
          tooltip: 'Cancella tutto',
          click: function () {
            //$( '.editor' ).summernote('reset');
            var $editor   = context.layoutInfo.editor;
            var $note = context.layoutInfo.note;
            $('.editor#' + $note[0].id ).summernote('reset');
          }
        });
      
        return button.render();   // return button as jquery object
    }

    // upload summenote images on server
    $.upload = function (file) {
        let out = new FormData();
        out.append('file', file, file.name);
        $.ajaxSetup({
            headers : { 'X-CSRF-TOKEN': $( 'input[name="_token"]' ).val() }
        });
        $.ajax({
            method: 'POST',
            url: '/admin/summernote-upload',
            contentType: false,
            cache: false,
            processData: false,
            data: out,
            success: function (img) {
                $('.editor').summernote('insertImage', img, 'picture');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error(textStatus + " " + errorThrown);
            }
        });
    };

    function summernoteUploadFile(file) {
        let data = new FormData();
        let textLink = file.filetext;
        let textPage = file.filepage;
        file = file.file[0];
        data.append("file", file);
        $.ajaxSetup({
            headers : { 'X-CSRF-TOKEN': $( 'input[name="_token"]' ).val() }
        });
        $.ajax({
            data: data,
            type: "POST",
            url: "/admin/summernote-file-upload", //Your own back-end uploader
            cache: false,
            contentType: false,
            processData: false,
            xhr: function() { //Handle progress upload
                let myXhr = $.ajaxSettings.xhr();
                if (myXhr.upload) myXhr.upload.addEventListener('progress', progressHandlingFunction, false);
                return myXhr;
            },
            success: function(reponse) {
                if(reponse.status === true) {

                    let listMimeImg = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/svg'];
                    let listMimeAudio = ['audio/mpeg', 'audio/ogg'];
                    let listMimeVideo = ['video/mpeg', 'video/mp4', 'video/webm'];
                    let elem;
    
                    if (listMimeImg.indexOf(file.type) > -1) {
                        //Picture
                        $('.editor').summernote('editor.insertImage', reponse.filename);
                    } else if (listMimeAudio.indexOf(file.type) > -1) {
                        //Audio
                        elem = document.createElement("audio");
                        elem.setAttribute("src", reponse.filename);
                        elem.setAttribute("controls", "controls");
                        elem.setAttribute("preload", "metadata");
                        $('.editor').summernote('editor.insertNode', elem);
                    } else if (listMimeVideo.indexOf(file.type) > -1) {
                        //Video
                        elem = document.createElement("video");
                        elem.setAttribute("src", reponse.filename);
                        elem.setAttribute("controls", "controls");
                        elem.setAttribute("preload", "metadata");
                        $('.editor').summernote('editor.insertNode', elem);
                    } else {
                        //Other file type
                        elem = document.createElement("a");
                        let linkText = document.createTextNode(textLink || file.name);
                        elem.appendChild(linkText);
                        elem.href = reponse.file.file;
                        elem.target = textPage;
                        $('.editor').summernote('editor.insertNode', elem);
                    }
                }
            }
        });
    }
    
    function progressHandlingFunction(e) {
        if (e.lengthComputable) {
            //Log current progress
            console.log((e.loaded / e.total * 100) + '%');
    
            //Reset progress on complete
            if (e.loaded === e.total) {
                console.log("Upload finished.");
            }
        }
    }

    $( '.editor' ).summernote({
        height: 500,
        lang: 'it-IT',
        callbacks: {
            onInit: function() {
                //$(this).data('image_dialog_images_html', '<div class="row"><div class="col-md-2 img-item"><img class="col-md-12 thumbnail" src="website.com/url/to/image.jpg" alt="a galerie test" /><i class="fa fa-check"></i></div></div>');
            },
            onPaste: function(e) {
                var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                e.preventDefault();
                document.execCommand('insertText', false, bufferText);
            },
            onImageUpload: function(files, target) {
                for(let i=0; i < files.length; i++) {
                    $.upload(files[i]);
                }
            },
            onFileUpload: function(file) {
                summernoteUploadFile(file);
            }
        },
        toolbar: [
            ['style',       ['codeview', 'style', 'bold', 'italic', 'underline', 'clear']],
            ['font',        ['strikethrough', 'superscript', 'subscript']],
            ['para',        ['ul', 'ol', 'paragraph']],
            ['table',       ['table']],
            ['insert',      ['link', 'picture', 'gallery', 'video', 'file']],
            ['misc',        ['clearAll']],
        ],
        popover: {
            image: [
                ['custom', ['imageAttributes']],
                //['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
                ['remove', ['removeMedia']],
            ],
        },
        imageAttributes: {
            icon: '<i class="note-icon-pencil"/>',
            figureClass: 'figureClass',
            figcaptionClass: 'captionClass',
            captionText: 'Caption Goes Here.',
            manageAspectRatio: true // true = Lock the Image Width/Height, Default to true
        },
        gallery: {
            source: {
                // data: [],
                url: '/admin/summernote-imageslist',
                responseDataKey: 'data',
                nextPageKey: 'Prossima',
            },
            modal: {
                loadOnScroll: true,
                title: "Galleria immagini",
                close_text: 'Annulla',
                ok_text: 'Inserisci',
                selectAll_text: 'Seleziona tutte',
                deselectAll_text: 'Deseleziona tutte',
                noImageSelected_msg: 'Nessuna immagine selezionata',
            }
        },
        buttons: {
            clearAll: clearAllButton
        }
    });

    // catch brand id & switch layout
    // fill editor with defaults layouts
    var brand = $( 'select[name="category"]' ).find( 'option:selected' ).attr('data-brand');
    $( '.standard' )
        .toggle( brand != 8 && brand != 9 );
    $( '.abc' )
        .toggle( brand == 8 );
    $( '.snack' )
        .toggle( brand == 9 );

    $( 'select[name="category"]' ).change(function( e ) {
        var brand = $( this ).find( 'option:selected' ).attr('data-brand');
        /*
        $( "#book" ).slideDown( "slow", function() {
        // Animation complete.
        });
        */
        if( brand == 8 || brand == 9 ) {
            $( '.standard' ).slideUp(500);
            if( brand == 8 ) {
                $( '.abc' ).slideDown(500);
                $( '.snack' ).slideUp(500);
            }
            if( brand == 9 ) {
                $( '.snack' ).slideDown(500);
                $( '.abc' ).slideUp(500);
            }
        } else {
            $( '.standard' ).slideDown(500);
            $( '.abc, .snack' ).slideUp(500);
        }
    });

    // fill editor with defaults layouts
    $( 'input[name="options"]' ).change(function( e ) {
        var layout = $( this ).val();
        var long_target = $( 'textarea.editor[name="long_description"]' );
        var short_target = $( 'textarea.editor[name="short_description"]' );

        switch (layout) {
            case 'layout_sample_right':
                var layout =    `<div class="row py-3 pb-sm-6">
                                    <div class="col-sm">
                                        <h3 class="pb-2 pb-sm-4">
                                            NEQUE PORRO QUISQUAM
                                            <br />
                                            EST QUI DOLOREM
                                        </h3>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                            In et magna malesuada, porttitor sem quis, varius nulla. 
                                            Integer nec pulvinar justo. Nullam ornare, tellus vel 
                                            ultrices mattis, urna ex malesuada diam, ut scelerisque 
                                            nibh tortor ut nisi. Cras semper malesuada fringilla. 
                                            Maecenas malesuada elit non blandit sollicitudin. Vivamus 
                                            sagittis rhoncus nulla a lobortis. Praesent pharetra viverra 
                                            cursus. Proin vestibulum malesuada leo, hendrerit posuere ligula 
                                            sollicitudin sit amet. Curabitur ornare, tortor vel pretium bibendum, 
                                            ante est tempor nulla, vitae semper nunc turpis a tellus.
                                        </p>
                                    </div>
                                    <div class="col-sm-auto">
                                        <img src="/images/sample-image.jpg">
                                    </div>
                                </div>`;
                break;
            case 'layout_sample_left':
                var layout =    `<div class="row py-3 pb-sm-6">
                                    <div class="col-sm-auto order-2 order-sm-1">
                                        <img src="/images/sample-image.jpg">
                                    </div>
                                    <div class="col-sm order-1 order-sm-2">
                                        <h3 class="pb-2 pb-sm-4">
                                            NEQUE PORRO QUISQUAM
                                            <br />
                                            EST QUI DOLOREM
                                        </h3>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                            In et magna malesuada, porttitor sem quis, varius nulla. 
                                            Integer nec pulvinar justo. Nullam ornare, tellus vel 
                                            ultrices mattis, urna ex malesuada diam, ut scelerisque 
                                            nibh tortor ut nisi. Cras semper malesuada fringilla. 
                                            Maecenas malesuada elit non blandit sollicitudin. Vivamus 
                                            sagittis rhoncus nulla a lobortis. Praesent pharetra viverra 
                                            cursus. Proin vestibulum malesuada leo, hendrerit posuere ligula 
                                            sollicitudin sit amet. Curabitur ornare, tortor vel pretium bibendum, 
                                            ante est tempor nulla, vitae semper nunc turpis a tellus.
                                        </p>
                                    </div>
                                </div>`;
                break;
            case 'layout_list_left':
                var layout =    `<div class="row align-items-center">
                                    <div class="col-sm">
                                        <h3>
                                            NEQUE PORRO QUISQUAM
                                            <br />
                                            EST QUI DOLOREM
                                        </h3>
                                    </div>
                                    <div class="col-sm">
                                        <div class="d-block py-3">
                                            <img src="/images/sample-image-circle.png" class="d-inline-block align-middle">
                                            <p class="d-inline-block w-60 pl-3 align-middle">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            </p>
                                        </div>
                                        <div class="d-block py-3">
                                            <img src="/images/sample-image-circle.png" class="d-inline-block align-middle">
                                            <p class="d-inline-block w-60 pl-3 align-middle">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            </p>
                                        </div>
                                    </div>
                                </div>`;
                break;
            case 'layout_list_right':
                var layout =    `<div class="row align-items-center">
                                    <div class="col-sm">
                                        <div class="d-block py-3">
                                            <img src="/images/sample-image-circle.png" class="d-inline-block align-middle">
                                            <p class="d-inline-block w-60 pl-3 align-middle">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            </p>
                                        </div>
                                        <div class="d-block py-3">
                                            <img src="/images/sample-image-circle.png" class="d-inline-block align-middle">
                                            <p class="d-inline-block w-60 pl-3 align-middle">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm">
                                        <h3>
                                            NEQUE PORRO QUISQUAM
                                            <br />
                                            EST QUI DOLOREM
                                        </h3>
                                    </div>
                                </div>`;
                break;
            case 'layout_modal':
                var layout =    `<div class="row align-items-center">
                                    <div class="col-sm">
                                        <div class="d-block py-3">
                                            <img src="/images/sample-image-circle.png" class="d-inline-block align-middle">
                                            <p class="d-inline-block w-60 pl-3 align-middle">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            </p>
                                        </div>
                                        <div class="d-block py-3">
                                            <img src="/images/sample-image-circle.png" class="d-inline-block align-middle">
                                            <p class="d-inline-block w-60 pl-3 align-middle">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm">
                                        <h3>
                                            NEQUE PORRO QUISQUAM
                                            <br />
                                            EST QUI DOLOREM
                                        </h3>
                                    </div>
                                </div>`;
                break;
            case 'layout_modal_complete':
                var layout =    `<div class="row w-xl-80 mx-auto">
                                    <div class="col-lg">
                                        <h4 class="-k mb-3 mb-sm-4">
                                            <strong class="d-block">MATRICOLA XXXX</strong>
                                            CONSECTETUR ADIPISCING ELIT
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                            In et magna malesuada, porttitor sem quis, varius nulla. 
                                            Integer nec pulvinar justo. Nullam ornare, tellus vel 
                                            ultrices mattis, urna ex malesuada diam, ut scelerisque 
                                            nibh tortor ut nisi. Cras semper malesuada fringilla.
                                        </p>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                            In et magna malesuada, porttitor sem quis, varius nulla. 
                                            Integer nec pulvinar justo. Nullam ornare, tellus vel 
                                            ultrices mattis, urna ex malesuada diam, ut scelerisque 
                                            nibh tortor ut nisi. Cras semper malesuada fringilla. 
                                            Maecenas malesuada elit non blandit sollicitudin. 
                                            <br/>
                                            Vivamus sagittis rhoncus nulla a lobortis. Praesent pharetra viverra 
                                            cursus. Proin vestibulum malesuada leo, hendrerit posuere ligula 
                                            sollicitudin sit amet. Curabitur ornare, tortor vel pretium bibendum, 
                                            ante est tempor nulla, vitae semper nunc turpis a tellus.
                                        </p>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                            In et magna malesuada, porttitor sem quis, varius nulla. 
                                            Integer nec pulvinar justo. Nullam ornare, tellus vel 
                                            ultrices mattis, urna ex malesuada diam, ut scelerisque 
                                            nibh tortor ut nisi.
                                        </p>
                                    </div>
                                    <div class="col-lg">
                                        <img src="/images/sample-image.jpg">
                                        <h5 class="-k font-weight-bold mt-3 mt-sm-4">
                                            CONSECTETUR ADIPISCING ELIT
                                        </h5>
                                        <ul class="bl-b py-3">
                                            <li>
                                                <strong>Indirizzo:</strong> Via ipsum, 240
                                            </li>
                                            <li>
                                                <strong>Località:</strong> Elit
                                            </li>
                                            <li>
                                                <strong>Comune:</strong> 41059 Dolor (AM)
                                            </li>
                                        </ul>
                                        <ul class="py-3">
                                            <li>
                                                <strong>Matricola:</strong> 2637
                                            </li>
                                            <li>
                                                <strong>Numero aziende agricole:</strong> 5
                                            </li>
                                            <li>
                                                <strong>Latte lavorato nel 2015:</strong> q.li 47.000
                                            </li>
                                            <li>
                                                <strong>Forme prodotte:</strong> 9.000 Lorem ipsum
                                            </li>
                                            <li>
                                                <strong>Certificazioni:</strong> Lorem ipsum dolor sit amet
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <label class="tag -d d-table mx-auto my-3 my-sm-4">
                                    DOVE SIAMO
                                </label>
                                <img src="/images/sample-image.jpg" class="d-block mx-auto">`;
                var short =    `<h4 class="-k mr-sm-auto">
                                    <strong class="d-block">MATRICOLA XXXX</strong>
                                    CONSECTETUR ADIPISCING ELIT
                                </h4>
                                <img src="/images/sample-image.jpg" class="my-3 my-sm-5 mr-sm-auto">
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                                    In et magna malesuada, porttitor sem quis, varius nulla. 
                                    Integer nec pulvinar justo. Nullam ornare, tellus vel 
                                    ultrices mattis, urna ex malesuada diam, ut scelerisque 
                                    nibh tortor ut nisi.
                                </p>`;
                short_target.summernote( 'pasteHTML', short );
                break;
            default:
                var layout =    `Undefined layout...`;
                break;
        }
    

        //target.summernote( 'reset' )
        long_target.summernote( 'pasteHTML', layout );

    });

    // Switch bootstrap custom control input (checkboxes) on change: assign value ( 1 check | 0 uncheck )
    $( '.main-form input[type="checkbox"].custom-control-input' ).each(function () {
        $('<input />')
            .attr( { 'name': $( this ).attr( 'name' ), 'type': 'hidden' } )
            .val( '0' )
            .insertBefore( $( this ) );
    })

    // Custom file input write files names after select
    
    $('.custom-file-input').on('change',function(e){
        var fileName = $(this).val();
        if(!e.target.files) return;
		
        var files = e.target.files;
        var names = []
        for(var i=0; i < files.length; i++) {
            names.push(files[i].name);
        }

        $(this).next('.custom-file-label').html(names.join(', '));
    })

    $( '.-remove' ).click(function (e) {

        var currentPath = window.location.pathname;
        var pathVars = currentPath.split('/');
        var edit = pathVars[pathVars.length-1];

        if (edit == 'edit') {

            var uri = currentPath.split('/edit');            
            var $this = $( this );
            var $inputFile = $this.attr( 'data-input' );
            $( 'input[name="' + $inputFile + '"]' ).val(null);
            $this.closest( 'div' ).remove();
            $.ajax({
                url     : uri[0] + '/auth',
                headers : { 'X-CSRF-TOKEN': $( 'input[name="_token"]' ).val() },
                type    : 'POST',
                dataType: 'json',
                success : function ( response ) 
                {
                    toastr.success('Authorization erased.')
                },
                error : function ( response ) 
                {
                    toastr.error('Delete issue. Try again later.')
                }
            });
            
        }
        
        e.preventDefault();
    })

});
